import { articles } from '@/mocks/articles';
import { sections } from '@/mocks/sections';
import type { Article, Section } from '@/types/content';

export const allArticles: Article[] = articles as Article[];
export const allSections: Section[] = sections as Section[];

export function getSection(slug?: string): Section | undefined {
  return allSections.find((item) => item.slug === slug);
}

export function getSectionName(slug?: string): string {
  return getSection(slug)?.name ?? '吃瓜动态';
}

export function getArticlesBySection(slug: string): Article[] {
  return allArticles.filter((item) => item.section === slug);
}

export function getArticleById(id?: string): Article | undefined {
  return allArticles.find((item) => item.id === id);
}

export function getHotArticles(limit = 5): Article[] {
  return allArticles
    .slice()
    .sort((a, b) => b.views - a.views)
    .slice(0, limit);
}

export function getLatestArticles(limit = 6): Article[] {
  return allArticles
    .slice()
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, limit);
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  const sameSection = allArticles.filter(
    (item) => item.section === article.section && item.id !== article.id,
  );
  if (sameSection.length >= limit) {
    return sameSection.slice(0, limit);
  }
  const others = allArticles.filter(
    (item) => item.section !== article.section && item.id !== article.id,
  );
  return [...sameSection, ...others].slice(0, limit);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export function formatDate(date: string): string {
  const [year, month, day] = date.split('-');
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

export function shortDate(date: string): string {
  const parts = date.split('-');
  return `${Number(parts[1])} 月 ${Number(parts[2])} 日`;
}